import type { GetArAgingReportResponse } from '@vy/api-definition';
import { GetArAgingReportResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useArAgingReport(options?: CustomUseQueryOptions<GetArAgingReportResponse>) {
  return useQuery({
    queryKey: queryKeys.arAgingReport(),
    queryFn: async () => {
      const api = getPrivateApi();

      const response = await api.getArAgingReport();

      return GetArAgingReportResponseSchema.parse(response);
    },
    ...options,
  });
}
